import { render, staticRenderFns } from "./DiagramHandList.vue?vue&type=template&id=0ad3d20c&"
import script from "./DiagramHandList.vue?vue&type=script&lang=js&"
export * from "./DiagramHandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports